import ListNotifications from "./ListNotifications.component.jsx";

export default ListNotifications;